"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANGE_ORDER_TYPE = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.changeOrderType = changeOrderType;
exports.isPickupPlacesLoaded = isPickupPlacesLoaded;
exports.loadPickupPlaces = loadPickupPlaces;
exports.confirmPage = confirmPage;
exports.formPage = formPage;
exports.resetVoucherState = resetVoucherState;
exports.getShoppingCart = getShoppingCart;
exports.deleteShoppingCart = deleteShoppingCart;
exports.insertCartItem = insertCartItem;
exports.removeCartItem = removeCartItem;
exports.updateQuantity = updateQuantity;
exports.placeOrder = placeOrder;
exports.confirmPayment = confirmPayment;

var _ShoppingCartUtil = require("../../utils/ShoppingCartUtil");

var _VoucherUtil = require("../../utils/VoucherUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_PICKUP_PLACES = "maaporssi/pickupVouchers/LOAD_PICKUP_PLACES";
var LOAD_PICKUP_PLACES_SUCCESS = "maaporssi/pickupVouchers/LOAD_PICKUP_PLACES_SUCCESS";
var LOAD_PICKUP_PLACES_FAIL = "maaporssi/pickupVouchers/LOAD_PICKUP_PLACES_FAIL";
var CREATE_VOUCHER_ORDER = "maaporssi/pickupVouchers/CREATE_VOUCHER_ORDER";
var CREATE_VOUCHER_ORDER_SUCCESS = "maaporssi/pickupVouchers/CREATE_VOUCHER_ORDER_SUCCESS";
var CREATE_VOUCHER_ORDER_FAIL = "maaporssi/pickupVouchers/CREATE_VOUCHER_ORDER_FAIL";
var CONFIRM_PAYMENT = "maaporssi/pickupVouchers/CONFIRM_PAYMENT";
var CONFIRM_PAYMENT_FAIL = "maaporssi/pickupVouchers/CONFIRM_PAYMENT_FAIL";
var CONFIRM_PAYMENT_SUCCESS = "maaporssi/pickupVouchers/CONFIRM_PAYMENT_SUCCESS";
var CONFIRM = "maaporssi/pickupVouchers/CONFIRM";
var BACK = "maaporssi/pickupVouchers/BACK";
var GET_SHOPPING_CART = "maaporssi/pickupVouchers/GET_SHOPPING_CART";
var RESET_VOUCHER_STATE = "maaporssi/pickupVouchers/RESET_VOUCHER_STATE";
var CHANGE_ORDER_TYPE = exports.CHANGE_ORDER_TYPE = "maaporssi/pickupVouchers/CHANGE_ORDER_TYPE";

var initialState = {
  orderType: _VoucherUtil.PICKUP_ORDER_TYPE,
  placesLoaded: false,
  confirmPage: false,
  cart: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_ORDER_TYPE:
      return (0, _extends3.default)({}, state, {
        placesLoading: false,
        placesLoaded: false,
        placesError: null,
        places: null
      });
    case LOAD_PICKUP_PLACES:
      return (0, _extends3.default)({}, state, {
        placesLoading: true
      });
    case LOAD_PICKUP_PLACES_FAIL:
      return (0, _extends3.default)({}, state, {
        placesLoading: false,
        placesLoaded: true,
        placesError: action.error.error
      });
    case LOAD_PICKUP_PLACES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        placesLoading: false,
        placesLoaded: true,
        places: action.result
      });
    case GET_SHOPPING_CART:
      return (0, _extends3.default)({}, state, {
        cart: action.payload
      });
    case CREATE_VOUCHER_ORDER:
      return (0, _extends3.default)({}, state, {
        placeOrderLoading: true
      });
    case CREATE_VOUCHER_ORDER_FAIL:
      return (0, _extends3.default)({}, state, {
        placeOrderLoading: false,
        placeOrderError: action.error.error || "ERROR"
      });
    case CREATE_VOUCHER_ORDER_SUCCESS:
      if (action.result.status === "PENDING_PAYMENT" && action.result.payment_url) {
        window.location = action.result.payment_url;
        return state;
      }
      return (0, _extends3.default)({}, state, {
        placeOrderLoading: false,
        placeOrderSuccess: action.result
      });
    case CONFIRM:
      return (0, _extends3.default)({}, state, {
        confirmPage: true
      });
    case BACK:
      return (0, _extends3.default)({}, state, {
        confirmPage: false
      });
    case CONFIRM_PAYMENT:
      return (0, _extends3.default)({}, state, {
        confirmPaymentLoading: true
      });
    case CONFIRM_PAYMENT_FAIL:
      return (0, _extends3.default)({}, state, {
        confirmPaymentLoading: false,
        confirmPaymentLoaded: true,
        confirmPaymentError: action.error.error
      });
    case CONFIRM_PAYMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        confirmPaymentLoading: false,
        confirmPaymentLoaded: true,
        confirmPaymentSuccess: action.result
      });
    case RESET_VOUCHER_STATE:
      return initialState;
    default:
      return state;
  }
}

function changeOrderType(orderType) {
  return {
    type: CHANGE_ORDER_TYPE,
    payload: orderType
  };
}

function isPickupPlacesLoaded(globalState) {
  return globalState.pickupVouchers && globalState.pickupVouchers.placesLoaded;
}

function loadPickupPlaces() {
  return {
    types: [LOAD_PICKUP_PLACES, LOAD_PICKUP_PLACES_SUCCESS, LOAD_PICKUP_PLACES_FAIL],
    promise: function promise(client) {
      return client.get("/soil_pickup_places");
    }
  };
}

function confirmPage() {
  return {
    type: CONFIRM
  };
}

function formPage() {
  return {
    type: BACK
  };
}

function resetVoucherState() {
  (0, _ShoppingCartUtil.removeItems)("pickup");
  return {
    type: RESET_VOUCHER_STATE
  };
}

function createCartAction() {
  return {
    type: GET_SHOPPING_CART,
    payload: (0, _ShoppingCartUtil.getItems)("pickup")
  };
}

function getShoppingCart() {
  return createCartAction();
}

function deleteShoppingCart() {
  (0, _ShoppingCartUtil.removeItems)("pickup");
  return createCartAction();
}

function insertCartItem(item) {
  (0, _ShoppingCartUtil.addItem)(item, "pickup");
  return createCartAction();
}

function removeCartItem(item) {
  (0, _ShoppingCartUtil.removeItem)(item, "pickup");
  return createCartAction();
}

function updateQuantity(item, quantity) {
  if (quantity < 1 || isNaN(quantity)) {
    (0, _ShoppingCartUtil.updateItemQuantity)(item, 1, "pickup");
  } else {
    (0, _ShoppingCartUtil.updateItemQuantity)(item, quantity, "pickup");
  }
  return createCartAction();
}

function placeOrder(formData) {
  return {
    types: [CREATE_VOUCHER_ORDER, CREATE_VOUCHER_ORDER_SUCCESS, CREATE_VOUCHER_ORDER_FAIL],
    promise: function promise(client) {
      return client.post("/soil_pickup_orders", {
        data: formData
      });
    }
  };
}

function confirmPayment(_ref) {
  var orderId = _ref.orderId,
      data = _ref.data;

  return {
    types: [CONFIRM_PAYMENT, CONFIRM_PAYMENT_SUCCESS, CONFIRM_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.post("/soil_pickup_orders/" + orderId + "/confirm", {
        data: data
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/pickupVouchers.js
 ** module id = 310
 ** module chunks = 0
 **/